import React from 'react'
import EntityToggle from './EntityToggle'
import { INBOUND, OUTBOUND } from '../useManageEntities'
import * as entityHeading from '../../../Constants/Constants'
import Style from '../manageEntities.module.css'

const iconFor = (entityName) => {
    const name = (entityName || '').toLowerCase()
    if (name.indexOf('cancel') !== -1) return 'uil-times'
    if (name.indexOf('customer') !== -1) return 'uil-user'
    if (name.indexOf('sales order') !== -1) return 'uil-shopping-cart'
    if (name.indexOf('product') !== -1) return 'uil-box'
    if (name.indexOf('order') !== -1) return 'uil-receipt'
    if (name.indexOf('invoice') !== -1) return 'uil-file-alt'
    if (name.indexOf('ship') !== -1) return 'uil-truck'
    if (name.indexOf('categor') !== -1) return 'uil-apps'
    if (name.indexOf('currency') !== -1) return 'uil-money-bill'
    if (name.indexOf('inventor') !== -1 || name.indexOf('stock') !== -1) return 'uil-box'
    return 'uil-database'
}

const descriptionFor = (entityName) => {
    const name = (entityName || '').toLowerCase()
    if (name.indexOf('cancel') !== -1) return 'Order cancellation events'
    if (name.indexOf('customer') !== -1) return 'Accounts and contact profiles'
    if (name.indexOf('sales order') !== -1) return 'Orders and fulfillment requests'
    if (name.indexOf('product') !== -1) return 'Catalog, pricing and variants'
    if (name.indexOf('order') !== -1) return 'Orders and fulfillment requests'
    if (name.indexOf('invoice') !== -1) return 'Billing and payment records'
    if (name.indexOf('ship') !== -1) return 'Tracking and delivery status'
    if (name.indexOf('categor') !== -1) return 'Catalog grouping and structure'
    if (name.indexOf('currency') !== -1) return 'Currency rates and conversions'
    if (name.indexOf('inventor') !== -1 || name.indexOf('stock') !== -1) return 'Stock levels across locations'
    return ''
}

const formatLastUpdate = (isoString) => {
    if (!isoString) return 'Never synced'
    const then = new Date(isoString).getTime()
    if (Number.isNaN(then)) return 'Never synced'

    const diffMinutes = Math.round((Date.now() - then) / 60000)
    if (diffMinutes < 1) return 'Just now'
    if (diffMinutes < 60) return `${diffMinutes} min ago`

    const diffHours = Math.round(diffMinutes / 60)
    if (diffHours < 24) return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`

    const diffDays = Math.round(diffHours / 24)
    return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`
}

const EntityRow = ({ entity, isSaving, canManage, onToggle }) => {
    const description = descriptionFor(entity.displayName)

    return (
        <tr className={isSaving ? Style.rowSaving : undefined}>
            <td className={Style.nameCell}>
                <span className={Style.entityIcon}>
                    <i className={iconFor(entity.displayName)} aria-hidden="true" />
                </span>
                <span className={Style.entityMeta}>
                    <span className={Style.entityName}>{entity.displayName}</span>
                    {description ? <span className={Style.entityDescription}>{description}</span> : null}
                </span>
            </td>
            <td>
                <EntityToggle
                    label={entityHeading.entityHeading.targetToSource}
                    isActive={entity.isInboundActive}
                    isEditable={entity.isInboundEditable}
                    canManage={canManage}
                    isSaving={isSaving}
                    onChange={(isActive) => onToggle(entity, INBOUND, isActive)}
                />
            </td>
            <td>
                <EntityToggle
                    label={entityHeading.entityHeading.sourceToTarget}
                    isActive={entity.isOutboundActive}
                    isEditable={entity.isOutboundEditable}
                    canManage={canManage}
                    isSaving={isSaving}
                    onChange={(isActive) => onToggle(entity, OUTBOUND, isActive)}
                />
            </td>
            <td className={Style.numericCell}>{entity.packetSize != null ? entity.packetSize : '—'}</td>
            <td className={Style.mutedCell}>{formatLastUpdate(entity.lastSyncTime)}</td>
        </tr>
    )
}

export default EntityRow
